import React from "react";
import { X, SwitchCamera, Star, Award, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * CameraHeader — top bar of the camera overlay.
 * Shows post-type badge, close button, and flip-camera button.
 */
const CameraHeader = ({
	postType,
	isContest,
	onClose,
	hasMultipleCameras,
	capturedImage,
	capturedVideo,
	capturedAudio,
	isCropping,
	mode,
	facingMode,
	onFlipCamera,
}) => {
	const showFlip =
		hasMultipleCameras &&
		!capturedImage &&
		!capturedVideo &&
		!capturedAudio &&
		!isCropping &&
		mode !== "audio";

	return (
		<div className="absolute left-0 right-0 top-0 z-10 flex items-start justify-between bg-gradient-to-b from-black/80 to-transparent p-4 pr-2">
			{/* Left side — post type badge */}
			<div className="flex flex-col gap-2">
				{postType || isContest ? (
					<div>
						{isContest ? (
							<div className="flex items-center gap-2 rounded-full bg-blue-500 px-4 py-2 text-sm font-semibold text-white shadow-lg">
								<Star size={16} />
								<span>Contest Submission</span>
							</div>
						) : null}
						{!isContest && postType === "glow" && (
							<div className="flex items-center gap-2 rounded-full bg-yellow-500 px-4 py-2 text-sm font-semibold text-white shadow-lg">
								<Star size={16} />
								<span>Glow Post</span>
							</div>
						)}
						{!isContest && postType === "pride" && (
							<div className="flex items-center gap-2 rounded-full bg-purple-500 px-4 py-2 text-sm font-semibold text-white shadow-lg">
								<Award size={16} />
								<span>Proud Post</span>
							</div>
						)}
						{!isContest && postType === "grateful" && (
							<div className="flex items-center gap-2 rounded-full bg-green-500 px-4 py-2 text-sm font-semibold text-white shadow-lg">
								<Heart size={16} />
								<span>Grateful Post</span>
							</div>
						)}
					</div>
				) : null}
			</div>

			{/* Right side — close + flip */}
			<div className="flex flex-col items-end gap-2">
				<Button
					onClick={onClose}
					variant="ghost"
					size="icon"
					className="bg-red-500 text-white hover:bg-red-600"
				>
					<X size={24} />
				</Button>

				{showFlip ? (
					<Button
						onClick={onFlipCamera}
						variant="ghost"
						size="icon"
						// [&_svg]:!size-10 overrides Button's default [&_svg]:size-4
						// rule, which was clamping the icon to 16px regardless of
						// the `size` prop on SwitchCamera.
						className="h-14 w-14 bg-transparent hover:bg-transparent md:hidden [&_svg]:!h-10 [&_svg]:!w-10"
						title="Flip camera"
						style={{
							color: "#ffffff",
							// Hard drop shadow so the white icon stays visible on
							// both dark and bright camera feeds.
							filter:
								"drop-shadow(0 0 2px rgba(0,0,0,0.9)) drop-shadow(0 0 4px rgba(0,0,0,0.6))",
						}}
					>
						<SwitchCamera strokeWidth={2.25} color="#ffffff" />
					</Button>
				) : null}
			</div>
		</div>
	);
};

export default CameraHeader;
